import type { RadioGroupProps } from '@radix-ui/react-radio-group'
import { Label, RadioGroup, RadioGroupItem } from './ui'
import { cn } from '@/lib/utils'

export interface RadioOption<TValue extends string> {
  value: TValue
  label: string
}

interface Props<TValue extends string> {
  className?: string

  value: TValue
  options: RadioOption<TValue>[]

  orientation?: RadioGroupProps['orientation']

  onChange(value: TValue): void
}

export function Radios<TValue extends string>({
  className,
  value,
  options,
  orientation = 'vertical',
  onChange,
}: Props<TValue>) {
  return (
    <RadioGroup
      className={cn(orientation === 'horizontal' && 'grid-flow-col', className)}
      orientation={orientation}
      value={value}
      onValueChange={onChange}
    >
      {options.map(radio => (
        <div key={radio.value} className="flex items-center gap-2">
          <RadioGroupItem value={radio.value} id={radio.value} />
          <Label htmlFor={radio.value} className="font-medium">
            {radio.label}
          </Label>
        </div>
      ))}
    </RadioGroup>
  )
}
